import type Message from 'owa-service/src/contract/Message';
import type ConversationNode from 'owa-service/src/contract/ConversationNode';
import { UNREAD_REPLIES_COUNT } from './useMailItemViewState';
import { logSpacesDatapoint } from 'owa-timestream-logging';

export default function getUnreadRepliesFromConversationNodes(
    itemId: string,
    conversationNodes: ConversationNode[]
) {
    let unreadRepliesCount = 0;
    const unreadReplies: Message[] = [];

    // find itemId in conversationNodes
    const itemIdIndex = conversationNodes.map(node => node?.Items[0]?.ItemId?.Id).indexOf(itemId);

    if (itemIdIndex != -1) {
        // iterate through nodes until we have 3 unread replies
        let idx = itemIdIndex + 1;
        while (idx < conversationNodes.length && unreadRepliesCount < UNREAD_REPLIES_COUNT) {
            let message = conversationNodes[idx].Items[0] as Message;
            if (!message.IsRead) {
                unreadRepliesCount++;
                unreadReplies.push(message);
            }
            idx++;
        }
    } else {
        logSpacesDatapoint('OUTLOOKSPACES_MAIL_ITEM_NOT_FOUND_IN_CONVERSATION');
    }

    return unreadReplies;
}
